/* ---------------------------------------------------------------------------
	スクロール処理

 // import scrollControl from "@/utils/scrollControl.js";と記載します。
 // 次に使用したい処理を下記のように指定します。
 // const { parentScrollRemove, parentScrollUnlock } = scrollControl();
 // 例）parentScrollRemove();
---------------------------------------------------------------------------- */

import { ref } from "vue";

export default function scrollControl() {
	const scrollStop = ref(false);

	/* ---------------------------------------------------------------------------
		親要素のscroll非表示
	---------------------------------------------------------------------------- */
	function parentScrollRemove() {
		let scrollY = window.scrollY;
		let scrollContent = document.getElementById("body");

		let htmlElement = document.getElementById("html");
		htmlElement.style.setProperty("overflow", "hidden");

		scrollContent.style.setProperty("height", "100%");
		scrollContent.style.setProperty("overflow", "visible");
		scrollContent.style.setProperty("right", "0");
		scrollContent.style.setProperty("left", "0");
		scrollContent.style.setProperty("top", "-" + scrollY + "px");
		scrollContent.style.setProperty("min-height", "100%");
		scrollContent.style.setProperty("position", "fixed");
	}

	// 親要素のscroll非表示解除
	function parentScrollUnlock() {
		let scrollContent = document.getElementById("body");
		let style = window.getComputedStyle(scrollContent);
		let value = style.getPropertyValue("top");
		let scrollValue = value.replace(/-/g, "").replace(/px/g, "");

		let htmlElement = document.getElementById("html");
		htmlElement.style.removeProperty("overflow");

		scrollContent.style.removeProperty("height");
		scrollContent.style.removeProperty("overflow");
		scrollContent.style.removeProperty("right");
		scrollContent.style.removeProperty("left");
		scrollContent.style.removeProperty("top");
		scrollContent.style.removeProperty("min-height");
		scrollContent.style.removeProperty("position");

		window.scrollTo(0, scrollValue);
	}

	return {
		scrollStop,
		parentScrollRemove,
		parentScrollUnlock
	};
}
